import { render, staticRenderFns } from "./GroupDeleteDialogue.vue?vue&type=template&id=1e454606&"
import script from "./GroupDeleteDialogue.vue?vue&type=script&lang=js&"
export * from "./GroupDeleteDialogue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports